import React, { useEffect, useState } from 'react';
import Heading from '../../common/Heading/Heading';
import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Row,
  Select,
  Spin,
  Input,
  Checkbox,
  Divider,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import {
  addLeaveAllocation,
  getLeaveAllocationDetails,
  updateLeaveAllocation,
} from '../../../network/leaveAllocation';
import dayjs from 'dayjs';
import { getSearchApi } from '../../../network/itemList';
import { getEmployee } from '../../../network/employee';
import {
  addEmployeeAdvance,
  getEmployeeAdvanceDetails,
  updateEmployeeAdvance,
} from '../../../network/employeeAdvance';
import { submitMaterialRequest } from '../../../network/materialRequest';
import { GiLevelThreeAdvanced } from 'react-icons/gi';
import HeadingApp from '../../../hooks/HeadingApp';
const AddEmployeeAdvance = ({ t, edit }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName } = useSelector((state) => state.user);
  const client = useQueryClient();
  const [selectName, setSelectName] = useState(null);
  const [dataStatus, setDataStatus] = useState(null);
  const [submitButton, setSubmitButton] = useState(false);
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { mutate: onAddEmployeeAdvance } = useMutation({
    mutationKey: ['addEmployeeAdvance'],
    mutationFn: (body) =>
      edit ? updateEmployeeAdvance(body, id) : addEmployeeAdvance(body),
    onSuccess: (data) => {
      setLoadingAdd(false);
      console.log(data?.message, 'datawwww');
      if (data?.message?.status === 500) {
        console.log(data, 'datawdkwokdowkfowfw500000000');

        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      setSelectName(edit ? id : data?.data?.name);
      setSubmitButton(true);
      client.invalidateQueries({ queryKey: [queryKeys.getEmployeeAdvance] });
      // form.resetFields();
      edit && dataStatus !== 0 && navigate('/employee-advance');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      console.log(messageData, 'messageData');

      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
      console.log('error:', error);
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Employee Advance', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getEmployeeAdvance] });
      navigate('/employee-advance');
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data: employeeAdvanceDetails, isLoading } = useQuery({
    queryKey: [queryKeys.getEmployeeAdvance, id],
    queryFn: () => getEmployeeAdvanceDetails(id),
    enabled: !!edit,
  });
  // const filter = ["employee_name","department","company"];
  // const { data: employee } = useQuery({
  //   queryKey: [queryKeys.getSearchApiEmployee],
  //   queryFn: () => getSearchApi('Employee',filter),
  //   keepPreviousData: true,
  // });
  const { data: employee } = useQuery({
    queryKey: [queryKeys.getEmployee],
    queryFn: () => getEmployee(),
  });
  // console.log(employee, 'employee');

  // const { data: advanceAccount } = useQuery({
  //   queryKey: [queryKeys.getSearchApiAdvanceAccount],
  //   queryFn: () => getSearchApi('Company name'),
  //   keepPreviousData: true,
  // });
  const { data: ModeOfPayment } = useQuery({
    queryKey: [queryKeys.getSearchApiModeOfPayment],
    queryFn: () => getSearchApi('Mode of Payment'),
    keepPreviousData: true,
  });
  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddEmployeeAdvance({
      ...values,
      company: companyName,
      advance_amount: Number(values?.advance_amount),
      posting_date: dayjs(values?.posting_date).format('YYYY-MM-DD'),
      exchange_rate: 1.0,
      repay_unclaimed_amount_from_salary:
        values?.repay_unclaimed_amount_from_salary ? 1 : 0,
    });
  };
  useEffect(() => {
    if (edit && employeeAdvanceDetails) {
      setDataStatus(employeeAdvanceDetails?.data?.docstatus);
      form.setFieldsValue({
        ...employeeAdvanceDetails?.data,
        posting_date: dayjs(employeeAdvanceDetails?.data?.posting_date),
      });
    } else {
      form.resetFields();
    }
  }, [edit, employeeAdvanceDetails, form]);
  if (isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.HR}
        subTitle={edit ? t.EditEmployeeAdvance : t.AddEmployeeAdvance}
        path="/employee-advance"
      /> */}
      <HeadingApp
        nameTab={t.HR}
        title={t.EmployeeAdvance}
        subTitle={edit ? t.EditEmployeeAdvance : t.AddEmployeeAdvance}
        icon={<GiLevelThreeAdvanced />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-employee-advance"
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: '20px' }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee"
                    label={t.Employee}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.Employee}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      onChange={(value, option) => {
                        console.log(option, 'option');
                        form.setFieldsValue({
                          employee_name: option?.option?.employee_name,
                          department: option?.option?.department,
                        });
                      }}
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={employee?.data?.map((user) => ({
                        value: user.name,
                        label: user.name,
                        option: user,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="employee_name"
                    label={t.employeeName}
                    rules={[{ required: true }]}
                  >
                    <Input placeholder={t.employeeName} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item name="department" label={t.department}>
                    <Input placeholder={t.department} disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="advance_account"
                    label={t.advanceAccount}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.advanceAccount}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={[
                        {
                          value: 'Employee Advances - S',
                          label: 'Employee Advances - S',
                        },
                      ]}
                      // options={advanceAccount?.message?.map((user) => ({
                      //   value: user.value,
                      //   label: user.value,
                      // }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="mode_of_payment"
                    label={t.ModeofPayment}
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder={t.ModeofPayment}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        (option?.label ?? '')
                          .toLocaleLowerCase()
                          .includes(input)
                      }
                      filterSort={(optionA, optionB) =>
                        (optionA?.label ?? '')
                          .toLowerCase()
                          .localeCompare((optionB?.label ?? '').toLowerCase())
                      }
                      options={ModeOfPayment?.message?.map((user) => ({
                        value: user.value,
                        label: user.value,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="posting_date"
                    label={t.postingDate}
                    rules={[{ required: true }]}
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      placeholder={t.postingDate}
                      format="YYYY-MM-DD"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} xl={8} xxl={8}>
                  <Form.Item
                    name="advance_amount"
                    label={t.advanceAmount}
                    rules={[{ required: true }]}
                  >
                    <Input type="number" placeholder={t.advanceAmount} />
                  </Form.Item>
                </Col>
                <Col
                  xs={12}
                  md={12}
                  xl={8}
                  xxl={8}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                >
                  <Form.Item
                    name="repay_unclaimed_amount_from_salary"
                    valuePropName="checked"
                    className="margin-bottom-0"
                  >
                    <Checkbox>{t.repayUnclaimedAmountFromSalary}</Checkbox>
                  </Form.Item>
                </Col>

                {edit ? (
                  <>
                    <Divider orientation="left">{t.Details}</Divider>

                    <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
                      <Form.Item name="pending_amount" label={t.pendingAmount}>
                        <Input
                          type="number"
                          placeholder={t.pendingAmount}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
                      <Form.Item name="paid_amount" label={t.PaidAmount}>
                        <Input
                          type="number"
                          placeholder={t.PaidAmount}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
                      <Form.Item name="claimed_amount" label={t.claimedAmount}>
                        <Input
                          type="number"
                          placeholder={t.claimedAmount}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
                      <Form.Item name="return_amount" label={t.returnAmount}>
                        <Input
                          type="number"
                          placeholder={t.returnAmount}
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12} xl={8} xxl={8} hidden={!edit}>
                      <Form.Item name="status" label={t.status}>
                        <Input placeholder={t.status} disabled />
                      </Form.Item>
                    </Col>
                  </>
                ) : null}
                <Col span={24}>
                  <Form.Item
                    name="purpose"
                    label={t.purpose}
                    rules={[{ required: true }]}
                  >
                    <Input.TextArea rows={4} placeholder={t.purpose} />
                  </Form.Item>
                </Col>
              </Row>
              <div className="form-btns">
                <Button type="primary" ghost onClick={() => navigate(-1)}>
                  {t.cancel}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    if (submitButton) {
                      setLoadingAdd(true);
                      handleSubmit.mutate(selectName);
                    } else {
                      form.submit();
                    }
                  }}
                  loading={loadingAdd}
                >
                  {/* {edit ? t.edit : t.submit} */}
                  {submitButton ? t.submit : edit ? t.edit : t.Save}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddEmployeeAdvance;
